import { Image, resolveAssetSource, getImageSize } from "./primitives"

// HMR 可能替换 forwardRef 组件但丢失静态方法，入口层再挂一次
Image.resolveAssetSource = resolveAssetSource
Image.getSize = getImageSize

export * from "./primitives"
export { default as styled, css, ThemeProvider, useTheme } from "./styled"
export * from "./safe-area"
export { default as LinearGradient } from "./LinearGradient"
export { default as Animated, useSharedValue, useAnimatedStyle, useAnimatedProps, withTiming, withSpring, runOnJS } from "./reanimated"

// 兼容旧 import 路径
export { TouchButton, TouchableView } from "./touchable"
export { DeviceEventEmitter as NativeEventEmitter } from "./events"
